import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { ObraCard, ObrasResponse } from '@/types/api';

// Query única ['obras'] compartida por la home (grilla + filtros) y el
// buscador global ⌘K — mismo cache, un solo round-trip. Los ~260 registros
// pesan poco (< 100 KB) y el filtrado es 100% client-side (MVP §5.1), así
// que no hay paginación server-side. staleTime 5 min: el origen (cache de
// maestros) se refresca cada ~30 min, no tiene sentido re-pedir por foco.
export function useObras() {
  return useQuery({
    queryKey: ['obras'],
    queryFn: () => api<ObrasResponse>('/api/obras'),
    select: (data): ObraCard[] => data.obras,
    staleTime: 5 * 60_000,
  });
}
